import { TypeEnum } from '@modules/order/models/type.enum';
import { ProcedureEnum } from '@core/procedure-helpers/models/procedure.enum';

export function isDentureRemovableFullDentureImplantBased(procedureId: ProcedureEnum, typeId: TypeEnum): boolean {
	return procedureId === ProcedureEnum.Denture_Removable && typeId === TypeEnum.Full_Denture_implant_based;
}